import * as FaIcons
    from "react-icons/fa";


/*
|--------------------------------------------------------------------------
| GET BACKEND ICON
|--------------------------------------------------------------------------
*/

export const getMenuIcon = (
    iconName
) => {

    if (
        !iconName
    ) {

        return FaIcons
            .FaCircle;

    }


    return (
        FaIcons[
            String(
                iconName
            ).trim()
        ] ||
        FaIcons
            .FaCircle
    );

};


/*
|--------------------------------------------------------------------------
| PREPARE BACKEND MENU
|--------------------------------------------------------------------------
*/

export const prepareMenuData = (
    menu = []
) => {

    if (
        !Array.isArray(
            menu
        )
    ) {

        return [];

    }


    return menu.map(
        (
            item
        ) => ({

            ...item,

            icon:
                getMenuIcon(
                    item?.icon
                ),

            children:
                Array.isArray(
                    item?.children
                )
                    ?
                    prepareMenuData(
                        item.children
                    )
                    :
                    undefined,

        })
    );

};


export default
    prepareMenuData;